import { descriptions } from './serviceDescriptionsData'

export getServiceDescription = (serviceName, serviceCall, profile, component) ->

  if serviceName is 'weaver-importer-exporter'
    switch profile
      when 'raw-xl'
        descriptions.rawXl
      when 'raw-csv'
        descriptions.rawCsv
      when 'raw-xml'
        descriptions.rawXml
      when 'raw-json'
        descriptions.rawJson
      when 'trig'
        descriptions.trig
      when 'yaml-to-rdfs'
        descriptions.yamlToRdfs
      when 'relatics-stream'
        descriptions.relaticsStream
      when 'bim360'
        descriptions.bim360
      when 'turtle'
        descriptions.turtle
      else
        descriptions.default
  else if serviceName is 'pythia-connector'
    switch serviceCall
      when 'predict'
        descriptions.predict
      when 'train'
        descriptions.train
      when 'getStatus'
        descriptions.getStatus
      else
        descriptions.default
  else if serviceName is 'weaver-transform'
    descriptions.weaverTransform
  else if serviceName is 'rdf-export-service'
    descriptions.rdfExport
  else if component is 'clear_space'
    descriptions.clearSpace
  else
    descriptions.default
